import {
  ApolloClient,
  Cache,
  Locale,
  registerEventTracker
} from '@sfstudios/shapeshifter';
import { getLocale } from '../deviceInfo';
import { getEnvVariable } from '../getEnvVariable';
import googleAnalyticsV4Tracker from './googleAnalyticsV4Tracker';
import splunkTracker from './splunkTracker';

export const registerAllTrackers = (client: ApolloClient): void => {
  if ((window as { Cypress?: unknown }).Cypress) return;

  const gaId = getEnvVariable('REACT_APP_GOOGLE_ANALYTICS_V4_ID', '');
  const locale = getLocale() ?? Locale.sv;
  const cache = client.cache as Cache;

  registerEventTracker(googleAnalyticsV4Tracker({ gaId, cache, locale }));
  registerEventTracker(splunkTracker(client));
};
